import { render, staticRenderFns } from "./OpcoesCancelamentoLicitacao.vue?vue&type=template&id=5235bffc&scoped=true"
import script from "./OpcoesCancelamentoLicitacao.vue?vue&type=script&lang=ts"
export * from "./OpcoesCancelamentoLicitacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235bffc",
  null
  
)

export default component.exports